import React from "react";
import { getAssigneeCreatedAtInfo } from "common-client/utils/linkedTasks";
import { Icon } from "../Common/Icons/LucideIcons";
import { Body } from "../Common/Typography";
import type { Task } from "./__queries__";
import {
  LinkedTaskContainer,
  LinkedTaskItem,
  LinkedTaskItemContent,
  LinkedTaskItemLink,
} from "./__styles__/LinkedTask";
import { useEditTaskModal } from "./Form/EditTaskForm";

type Props = {
  tasks: Task[];
};

function LinkedTaskItemRow({ task }: { task: Task }) {
  const assigneeCreatedAtInfo = getAssigneeCreatedAtInfo(
    task.createdAt,
    task.assignees,
  );

  const [showTaskModal] = useEditTaskModal({
    taskId: task.id,
  });

  return (
    <LinkedTaskItem>
      <Icon
        iconName="circle-alert"
        color="contentInfo"
        size={16}
        style={{ marginTop: 2 }}
      />
      <LinkedTaskItemContent>
        <Body size="default" type="emphasis">
          Linked task:
          <LinkedTaskItemLink onClick={() => showTaskModal()}>
            {task.name}
          </LinkedTaskItemLink>
        </Body>
        {assigneeCreatedAtInfo && (
          <Body size="default" type="regular">
            {assigneeCreatedAtInfo}
          </Body>
        )}
      </LinkedTaskItemContent>
    </LinkedTaskItem>
  );
}

export function LinkedTask({ tasks }: Props) {
  if (!tasks || tasks.length === 0) {
    return null;
  }

  return (
    <LinkedTaskContainer>
      {tasks.map(task => (
        <LinkedTaskItemRow key={task.id} task={task} />
      ))}
    </LinkedTaskContainer>
  );
}
